<template>
	<span class="created" v-if="rowData.status === 0">Draft</span>
	<span class="created" v-else-if="rowData.status === 1">Pending</span>
	<span class="created" v-else>{{ date }}</span>
</template>

<script>
	import format from 'date-fns/format';

	export default {
		name: 'ColumnCreated',
		props: {
			rowData: {
				type: Object,
				required: true
			},
			rowIndex: {
				type: Number
			}
		},
		computed: {
			date() {
				return this.rowData.createdAt ? format(this.rowData.createdAt, 'dd/MM/yy') : 'Unknown';
			}
		}
		//Use computed properties instead of data here, otherwise sorting/pagination will break
	}
</script>

<style lang="scss" scoped>
	.created {
		text-transform: uppercase;
	}
</style>
